/**
 * Activate button component.
 */
import Activate from '@components/atoms/buttons/activateButton';
import Props from '@shared/types/props/pressable';
import useButton from './useButton';

export default function ActivateButton(parentProps: Props) {
  const { callbacks, props, buttonText } = useButton({
    ...parentProps,
    text: 'MODAL.ANONYMOUS.BUTTONS.ACTIVATE',
  });
  return (
    <Activate {...props} {...callbacks}>
      {buttonText}
    </Activate>
  );
}
